import React, { useState, useEffect } from "react";
import VentasUploader from "../VentasUploader";
import VentasConsulta from "../VentasConsulta";
import SubirExistencias from "../ExistenciasCedis";
import SubirExistenciasSucursal from "../ExistenciasSucursal";
import DashboardVentas from "../Dashboard/DashboardVentas";
import GenerarPedido from "../GenerarPedido";
import SubirCatalogoReducido from "../Subir_descatalogados";
import SubirOfertasXML from "../OfertasPasadas";
import VentasPasadas from "../VentasPasadas";
import InventarioNormalizado from "../sugerido";
import "./App.css";
import AdminDeleteSucursal from "../AdminDeleteSucursal";
import SubirPedidos from "../SubirPedidos";
import ConfigMultiplicadores from "../ConfigMultiplicadores";

function App() {
  const [activePage, setActivePage] = useState("ventas");
  const [actualizaciones, setActualizaciones] = useState({});
  const [logs, setLogs] = useState("");
  const [isLogsOpen, setIsLogsOpen] = useState(false);
  const [isConfigOpen, setIsConfigOpen] = useState(false);

  const toggleLogs = () => {
    setIsLogsOpen(!isLogsOpen);
  };

  useEffect(() => {
    const almacenes = ["GC1", "GC2", "GP1", "GP2", "OFERTAS"];

    const fetchActualizaciones = async () => {
      const resultados = {};
      for (const almacen of almacenes) {
        try {
          const res = await fetch(`${process.env.REACT_APP_API_URL}/cedis/ultima-actualizacion/?almacen=${almacen}&t=${Date.now()}`);
          const data = await res.json();
          resultados[almacen] = data.fecha_actualizacion || "No disponible";
        } catch {
          resultados[almacen] = "No disponible";
        }
      }
      setActualizaciones(resultados);
    };

    fetchActualizaciones();

    const interval = setInterval(fetchActualizaciones, 120000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/logs/ultimos?t=${Date.now()}`);
        const text = await res.text();
        setLogs(text);
      } catch (error) {
        setLogs("Error al cargar logs");
      }
    };

    fetchLogs();
    const interval = setInterval(fetchLogs, 15000); // cada 15 segundos

    return () => clearInterval(interval);
  }, []);

  // Activación oculta: Ctrl+Shift+D abre la pantalla admin
  useEffect(() => {
    const onKey = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'd') {
        setActivePage('adminDelete');
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);



  return (
    <div className="App" style={{ position: "relative", minHeight: "100vh" }}>
      <h1>Gestión de Pedidos</h1>

      <nav>
        <button onClick={() => setActivePage("ventas")} className={activePage === "ventas" ? "active" : ""}>
          Subir las Ventas de las Sucursales
        </button>
        <button onClick={() => setActivePage("existenciasucursal")} className={activePage === "existenciasucursal" ? "active" : ""}>
          Subir Existencias de las Sucursales
        </button>
        <button onClick={() => setActivePage("existencias")} className={activePage === "existencias" ? "active" : ""}>
          Subir Existencias de CEDIS
        </button>
        <button onClick={() => setActivePage("generarPedido")} className={activePage === "generarPedido" ? "active" : ""}>Generacion de Pedidos</button>
        <button onClick={() => setActivePage("reducido")} className={activePage === "reducido" ? "active" : ""}>Subir catalogo Reducido</button>
        <button onClick={() => setActivePage("ofertasxml")} className={activePage === "ofertasxml" ? "active" : ""}>
          Subir Ofertas Pasadas
        </button>
        <button onClick={() => setActivePage("consulta")} className={activePage === "consulta" ? "active" : ""}>
          Consultar Productos
        </button>
        {/*<button onClick={() => setActivePage("inventarioNormalizado")} className={activePage === "inventarioNormalizado" ? "active" : ""}>
          Sugerido
        </button>*/}
        <button onClick={() => setActivePage("subirPedidos")} className={activePage === "subirPedidos" ? "active" : ""}>
          Subir Pedidos
        </button>
      </nav>

      {/* Recuadro de actualizaciones de todos los almacenes */}
      <div className="recuadro-actualizacion">
        <strong>Última actualización de existencias por almacén:</strong>
        <ul>
          {["GC1", "GC2", "GP1", "GP2", "OFERTAS"].map(almacen => (
            <li key={almacen}>
              <b>{almacen}:</b> {actualizaciones[almacen]}
            </li>
          ))}
        </ul>
      </div>

      <div className={`log-panel ${isLogsOpen ? 'open' : 'closed'}`}>
        <div className="log-header" onClick={toggleLogs}>
          <h2>Últimas acciones {isLogsOpen ? '▼' : '▲'}</h2>
        </div>
        {isLogsOpen && (
          <div className="recuadro-logs">
            <pre style={{ background: "#f0f0f0", padding: "10px", height: "300px", overflowY: "auto", margin: 0 }}>
              {logs}
            </pre>
          </div>
        )}
      </div>

      <ConfigMultiplicadores isOpen={isConfigOpen} toggleOpen={() => setIsConfigOpen(!isConfigOpen)} />

      {activePage === "ventas" && <VentasUploader />}
      {activePage === "consulta" && <VentasConsulta />}
      {activePage === "existenciasucursal" && <SubirExistenciasSucursal />}
      {activePage === "existencias" && <SubirExistencias />}
      {activePage === "dashboard" && <DashboardVentas />}
      {activePage === "generarPedido" && <GenerarPedido />}
      {activePage === "reducido" && <SubirCatalogoReducido />}
      {activePage === "ofertasxml" && <SubirOfertasXML />}
      {activePage === "ventasPasadas" && <VentasPasadas />}
      {activePage === "inventarioNormalizado" && <InventarioNormalizado />}
      {activePage === "subirPedidos" && <SubirPedidos />}
      {activePage === "adminDelete" && <AdminDeleteSucursal />}
    </div>
  );
}

export default App; 
